import './normal.css';
import './App.css';
import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from './components/Loader';
import { getIsAuthenticated } from './store/slices/authSlice';

const Home = lazy(() => import('./pages/Home'));
const Authenticating = lazy(() => import('./pages/Authenticating'));
const Login = lazy(() => import('./pages/Login/Login'));
const Privacy = lazy(() => import('./pages/Privacy/Privacy'));

const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isAuthenticated = useSelector(getIsAuthenticated);

  return isAuthenticated ? <>{children}</> : <Navigate to="auth/login" />;
};

function App() {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route
          index
          path="/"
          element={
            <RequireAuth>
              <Home />
            </RequireAuth>
          }
        />
        <Route
          path="auth/google-oauth2/login/callback"
          element={<Authenticating />}
        />
        <Route path="auth/login" element={<Login />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </Suspense>
  );
}

export default App;
